import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SystemAnnouncementsComponent } from './system-announcements.component';
import { AnnouncementSidebarComponent } from './announcement-sidebar/announcement-sidebar.component';
import { SystemAnnouncementService } from './system-announcements.service';
import { CommonSharedModule } from '../common/shared.module';
import { RichTextEditorModule } from '../common/rich-text-editor/rich-text-editor.module';

import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    AccordionModule,
    SidebarModule,
    FloatLabelModule,
    InputTextModule,
    TableModule,
    RichTextEditorModule,
    CommonSharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: SystemAnnouncementsComponent
      }
    ])
  ],
  declarations: [AnnouncementSidebarComponent, SystemAnnouncementsComponent],
  providers: [SystemAnnouncementService, MessageService]
})
export class SystemAnnouncementsModule {}
